import React, { useReducer } from "react";
import { SET_ALERT, CLEAR_ALERT } from "../types";
import AlertReducer from "./AlertReducer";
import AlertContext from "./AlertContext";
import { v4 as uuidv4 } from "uuid";
const AlertState = ({ children }) => {
  const initialState = [];
  const [state, dispatch] = useReducer(AlertReducer, initialState);
  const setAlert = ({ msg, color, bgColor, timeOut = 5000 }) => {
    let id = uuidv4();
    dispatch({
      type: SET_ALERT,
      payload: { id, msg, color, bgColor, timeOut },
    });
    setTimeout(() => {
      dispatch({ type: CLEAR_ALERT, payload: id });
    }, timeOut);
  };
  return (
    <AlertContext.Provider value={{ setAlert, alerts: state }}>
      {children}
    </AlertContext.Provider>
  );
};

export default AlertState;
